var map = {
	"./_new_react/habitat-async.js": "IV6V",
	"./category_archive/habitat-async.js": "pepl",
	"./download/habitat-async.js": "mzrh",
	"./events_archive/habitat-async.js": "4WGi",
	"./image_slider/habitat-async.js": "GZBd",
	"./interviews/habitat-async.js": "CkGb",
	"./people_filters/habitat-async.js": "XbOp",
	"./press_archive/habitat-async.js": "zLkP",
	"./publications/habitat-async.js": "7LvN",
	"./publications_researchdata/habitat-async.js": "SLvp",
	"./videos/habitat-async.js": "Grcz"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "H1fm";